export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1A2B4A] text-white py-20">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-8">
              <img
                src="https://public.readdy.ai/ai/img_res/ffeb34b9-9575-4094-bf02-832cfc639083.png"
                alt="SERGAS S.R.L."
                className="h-14 w-auto"
              />
              <h3 className="text-4xl font-bold">SERGAS</h3>
            </div>
            <p className="text-white/80 leading-relaxed mb-8">
              Protecting your digital freedom with enterprise-grade VPN security. Browse anonymously, stream freely, and stay secure online.
            </p>
            <div className="flex items-center gap-5">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#00A8E8] hover:bg-[#00A8E8] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#00A8E8] hover:bg-[#00A8E8] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#00A8E8] hover:bg-[#00A8E8] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#00A8E8] hover:bg-[#00A8E8] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-wider text-white/60 mb-4 font-semibold">
              LOCATION
            </div>
            <div className="text-white/90 leading-relaxed mb-8">
              Vicalte Eduardo O'Connor 665<br />
              San Carlos de Bariloche<br />
              R8400ACI, Argentina
            </div>

            <div className="text-xs uppercase tracking-wider text-white/60 mb-4 font-semibold">
              CONTACT
            </div>
            <div className="space-y-2">
              <a href="tel:+17754028843" className="block text-white/90 hover:text-[#00A8E8] transition-colors">
                +1 775 402 8843
              </a>
              <a href="mailto:info@sergassrl.com" className="block text-white/90 hover:text-[#00A8E8] transition-colors">
                info@sergassrl.com
              </a>
            </div>
          </div>

          <div className="flex justify-center md:justify-end">
            <img
              src="https://public.readdy.ai/ai/img_res/fc5c929f780aa26f790fbb4cc80ed1d2.jpg"
              alt="Security Icon"
              className="w-44 h-44 object-contain opacity-80"
            />
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-sm text-white/70">
            © 2025 SERGAS S.R.L. All rights reserved.
          </div>
          <div className="flex items-center gap-8">
            <button
              onClick={() => scrollToSection('privacy')}
              className="text-sm text-white/70 hover:text-[#00A8E8] transition-colors cursor-pointer"
            >
              Privacy Policy
            </button>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white/70 hover:text-[#00A8E8] transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
